<!--
 * @Date: 2022-09-26 10:50:19
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-13 10:30:35
 * @description: description
 * 资质荣誉
-->
<template>
  <div :class="$style.honor">
    <div :class="$style.title">{{ info.title }}</div>
    <div :class="$style.authenticationBox">
      <div :class="$style.rightTopBg" />
      <div
        :class="$style.authenticationItem"
        v-for="(item, index) in info.authentication"
        :key="index"
      >
        <img :class="$style.itemImg" :src="item.cover" alt="" />
        <div :class="$style.itemContent">{{ item.content }}</div>
      </div>
    </div>
    <div :class="$style.infoBox">
      <div :class="$style.leftBg" />
      <div :class="$style.rightBottomBg" />
      <div :class="$style.contentBox">
        <div :class="$style.boxLogoBg" />
        <div :class="$style.firstLine">
          <!-- 模块左上 权威机构背书 -->
          <div :class="$style.backgroundBox">
            <div :class="$style.titleBox">
              <span :class="[$style.backgroundTitle, $style.titleBg]">{{
                info.background.title
              }}</span>
            </div>
            <div
              :class="$style.itemInfo"
              v-for="(item, index) in info.background.content"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <!-- 模块右上 教育培训林俊企业 -->
          <div :class="$style.leadingEnterpriseBox">
            <div :class="$style.titleBox">
              <span :class="[$style.leadingEnterpriseTitle, $style.titleBg]">
                {{ info.leadingEnterprise.title }}
              </span>
            </div>
            <div :class="$style.itemBox">
              <div :class="$style.itemBoxLeft">
                <div
                  :class="$style.itemInfo"
                  v-for="(item, index) in info.leadingEnterprise.contentLeft"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
              <div :class="$style.itemBoxRight">
                <div
                  :class="$style.itemInfo"
                  v-for="(item, index) in info.leadingEnterprise.contentRight"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="$style.firstLine">
          <!-- 模块坐下 高科技企业 -->
          <div :class="$style.scienceBox">
            <div :class="$style.titleBox">
              <span :class="[$style.scienceTitle, $style.titleBg]">{{
                info.science.title
              }}</span>
            </div>
            <div :class="$style.scienceItemBox">
              <div :class="$style.itemBoxLeft">
                <div
                  :class="$style.itemInfo"
                  v-for="(item, index) in info.science.contentLeft"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
              <div :class="$style.itemBoxRight">
                <div
                  :class="$style.itemInfo"
                  v-for="(item, index) in info.science.contentRight"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <!-- 模块右下 党建工作 -->
          <div :class="$style.partyBuildingBox">
            <div :class="$style.titleBox">
              <span :class="[$style.partyBuildingTitle, $style.titleBg]">{{
                info.partyBuilding.title
              }}</span>
            </div>
            <div
              :class="$style.itemInfo"
              v-for="(item, index) in info.partyBuilding.content"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'aboutus-honor',
  props: {
    info: Object
  }

}
</script>

<style lang="scss" module>
.honor {
  position: relative;
  width: 100%;
  // height: 946px;
  margin: 0 auto;
  padding-bottom: 80px;
  background: linear-gradient(3deg, #fff9f0 0%, #fff8ec 100%);
  text-align: center;

  .infoBox {
    position: relative;
    width: 1200px;
    height: 499px;
    margin: 0 auto;
  }

  .leftBg {
    position: absolute;
    left: -322px;
    top: 106px;
    z-index: 9;
    width: 372px;
    height: 372px;
    background-image: url("../../../assets/img/aboutus/pc/honor/honor-left-bg.png");
    background-size: 100% 100%;
  }

  .rightTopBg {
    position: absolute;
    right: -125px;
    top: -50px;
    z-index: 9;
    width: 177px;
    height: 133px;
    background-image: url("../../../assets/img/aboutus/pc/honor/honor-right-top.png");
    background-size: 100% 100%;
  }

  .rightBottomBg {
    position: absolute;
    right: -267px;
    bottom: -100px;
    z-index: 9;
    width: 410px;
    height: 400px;
    background-image: url("../../../assets/img/aboutus/pc/honor/honor-right-bottom.png");
    background-size: 100% 100%;
  }

  .boxLogoBg {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 9;
    width: 210px;
    height: 140px;
    background-image: url("../../../assets/img/aboutus/pc/honor/honor-log.png");
    background-size: 100% 100%;
  }

  .title {
    box-sizing: border-box;
    margin-bottom: 32px;
    padding-top: 60px;
    line-height: 45px;
    font-size: 32px;
    font-weight: 500;
    color: #404040;
  }

  .authenticationBox {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto 30px;
  }

  .authenticationItem {
    box-sizing: border-box;
    position: relative;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 380px;
    height: 140px;
    padding: 36px 50px 36px 32px;
    background: linear-gradient(163deg, #fff5e7 0%, #ffffff 100%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset 2px 2px 0px 0px #ffffff;
    border-radius: 6px;
  }

  .itemImg {
    display: block;
    width: 68px;
    height: 68px;
    margin-right: 30px;
  }

  .itemContent {
    width: 200px;
    height: 44px;
    line-height: 22px;
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    color: #404040;
  }

  .contentBox {
    position: relative;
    z-index: 99;
    padding: 30px 32px 30px 30px;
    background: linear-gradient(153deg, #fff5e7 0%, #ffffff 70%, #ffffff 100%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset 2px 2px 0px 0px #ffffff;
    border-radius: 6px;
  }

  .firstLine {
    display: flex;
    text-align: left;
  }

  .backgroundBox {
    // width: 569px;
    // height: 235px;
    width: 571px;
    height: 236px;
    border-right: 1px dashed #eff0f2;
    border-bottom: 1px dashed #eff0f2;
  }

  .leadingEnterpriseBox {
    height: 138px;
    width: 535px;
    padding-left: 29px;
  }

  .itemBox {
    display: flex;
    width: 535px;
    padding: 0 0 98px 0;
  }

  .scienceBox {
    width: 571px;
    padding-top: 29px;
  }

  .scienceItemBox {
    display: flex;
  }

  .itemBoxLeft {
    margin-right: 26px;
  }

  .titleBox {
    margin-bottom: 20px;
  }

  .leadingEnterpriseTitle,
  .backgroundTitle,
  .scienceTitle,
  .partyBuildingTitle {
    height: 28px;
    padding-left: 23px;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #e7b15f;
  }

  .titleBg {
    position: relative;

    &::before,
    &::after {
      content: "";
      position: absolute;
      right: 0;
      width: 14px;
      height: 26px;
      background-size: 100%;
    }

    &::before {
      top: 0;
      left: 0;
      background-image: url("../../../assets/img/aboutus/pc/honor/honor-title-left.png");
    }

    &::after {
      right: -23px;
      top: 0;
      background-image: url("../../../assets/img/aboutus/pc/honor/honor-title-right.png");
    }
  }

  .itemInfo {
    position: relative;
    height: 22px;
    margin-bottom: 12px;
    padding-left: 10px;
    line-height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #404040;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: "";
      position: absolute;
      left: 0;
      // top: 9px;
      top: 8px;
      width: 4px;
      height: 4px;
      background: #b2b2b2;
      border-radius: 50%;
    }
  }

  .partyBuildingBox {
    width: 567px;
    height: 162px;
    margin: -1px;
    padding: 30px 0 0 30px;
    border-top: 1px dashed #eff0f2;
    border-left: 1px dashed #eff0f2;
  }
}
</style>
